// src/components/AuthForm.tsx
import React from "react";
import { Button } from "./Button";
import "./styles/Login.css";

interface AuthFormProps {
  email: string;
  password: string;
  confirmPassword?: string;
  error?: string;
  onEmailChange: (value: string) => void;
  onPasswordChange: (value: string) => void;
  onConfirmPasswordChange?: (value: string) => void;
  onSubmit: (e: React.FormEvent) => void;
  buttonText: string;
  isLoading: boolean;
  children?: React.ReactNode;
}

const AuthForm: React.FC<AuthFormProps> = ({
  email,
  password,
  confirmPassword,
  error,
  onEmailChange,
  onPasswordChange,
  onConfirmPasswordChange,
  onSubmit,
  buttonText,
  isLoading,
  children,
}) => {
  return (
    <form onSubmit={onSubmit} className="login-form">
      <input
        type="email"
        name="email"
        placeholder="Email"
        required
        className="login-input"
        value={email}
        onChange={(e) => onEmailChange(e.target.value)}
      />
      <input
        type="password"
        name="password"
        placeholder="Password"
        required
        className="login-input"
        value={password}
        onChange={(e) => onPasswordChange(e.target.value)}
      />
      {onConfirmPasswordChange && (
        <input
          type="password"
          name="confirmPassword"
          placeholder="Confirm Password"
          required
          className="login-input"
          value={confirmPassword}
          onChange={(e) => onConfirmPasswordChange(e.target.value)}
        />
      )}
      {error && <p className="login-error">{error}</p>}
      <Button loading={isLoading} type="submit" className="login-button">
        {buttonText}
      </Button>
      {children}
    </form>
  );
};

export default AuthForm;